import { Button } from "./ui/button";
import heroImage from "../assets/hr-hero-diverse.jpg";

const BizServePortalHero = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Hero Image */}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative">
        <img
          src={heroImage}
          alt="BizServe - Your All-in-One Business Management Platform"
          className="w-full h-full object-cover"
        />
        {/* Blue to purple overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/60 to-purple-600/60"></div>
      </div>

      {/* Hero Content */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-16">
            Your All-in-One Business Management Platform
          </h1>
          <br />
          <br />
          <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8">
            From startup to success, BizServe guides you through every step of
            building and growing your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="text-lg px-8 py-3">
              Start Your Business Today
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-lg px-8 py-3 bg-white/10 border-white/20 text-white hover:bg-white/20"
            >
              Explore Services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BizServePortalHero;
